// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PremiumPlanOption--option {
  -webkit-box-flex: 1;
      -ms-flex: 1;
          flex: 1;
  border: 1px solid #E8E9F0;
  margin-left: 20px;
  position: relative;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  padding-bottom: 36px;
  max-width: 300px;
  width: 270px;
}
.PremiumPlanOption--current {
  border-color: #078E64;
}
.PremiumPlanOption__no-price-spacer {
  line-height: 20px;
  padding-bottom: 24px;
}
.PremiumPlanOption__no-price-spacer:before {
  display: block;
  content: " ";
}
.PremiumPlanOption__recommended-badge {
  position: absolute;
  width: 100%;
  font-size: 9px;
  color: #002E33;
  font-weight: 900;
  text-align: center;
  letter-spacing: 0.7px;
  text-transform: uppercase;
  background-color: #DBD4FF;
  border: 1px solid #DBD4FF;
  line-height: 22px;
  top: -25px;
  left: -1px;
}
.PremiumPlanOption__current_ending {
  border-top: 1px solid #002E33;
  border-bottom: 1px solid #F5F6F9;
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
}
.PremiumPlanOption__current_ending__cancel_link {
  line-height: 23px !important;
  font-weight: 500 !important;
  font-size: 11px !important;
}
.PremiumPlanOption__current_ending__title {
  line-height: 16px;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 900;
  text-align: center;
  color: #697588;
  margin-bottom: 7px;
}
.PremiumPlanOption__current_ending__status {
  display: inline-block;
  color: #FFF;
  border-radius: 16px;
  padding: 4px 10px;
  background-color: #697588;
  margin-bottom: 7px;
}
.PremiumPlanOption__new_plan {
  border-top: 1px solid #F5F6F9;
  border-bottom: 1px solid #F5F6F9;
  padding-bottom: 12px;
}
.PremiumPlanOption__new_plan__title {
  padding-top: 12px;
  line-height: 16px;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 900;
  text-align: center;
  color: #002E33;
}
.PremiumPlanOption__new_plan__starting {
  padding-top: 7px;
  font-size: 11px;
  font-weight: 500;
  text-align: center;
}
.PremiumPlanOption__link-button {
  color: #FFF;
  -webkit-text-decoration: none;
  text-decoration: none;
}
.PremiumPlanOption__name {
  font-size: 14px;
  font-weight: 900;
  line-height: 1.14;
  letter-spacing: 1.1px;
  text-align: center;
  text-transform: uppercase;
  color: #002E33;
  margin-top: 36px;
}
.PremiumPlanOption__contact-us {
  font-size: 1.3rem;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  text-align: center;
  color: #002E33;
  margin-top: 17px;
  padding: 1.2rem 0;
}
.PremiumPlanOption__price {
  font-size: 32px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  text-align: center;
  color: #002E33;
  margin-top: 17px;
}
.PremiumPlanOption__price-label {
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: #002E33;
  margin-top: 7px;
}
.PremiumPlanOption__price-label_secondary {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  color: #002E33;
  margin-top: 7px;
}
.PremiumPlanOption__action {
  margin-top: 18px;
  padding-left: 20px;
  padding-right: 20px;
}
.PremiumPlanOption__action .Button {
  width: 100%;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  line-height: 40px;
  text-align: center;
  padding-top: 0;
  padding-bottom: 0;
}
.PremiumPlanOption__action .Button.cancel {
  background-color: #F7DDD9;
}
.PremiumPlanOption__action-current {
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: #002E33;
  border-bottom: 1px solid #F5F6F9;
  border-top: 1px solid #F5F6F9;
}
.PremiumPlanOption__features {
  margin-top: 37px;
  padding-left: 20px;
  padding-right: 20px;
}
.PremiumPlanOption__feature-highlights {
  padding-bottom: 15px;
  border-bottom: 1px solid #F5F6F9;
  margin-bottom: 15px;
}`, "",{"version":3,"sources":["webpack://./src/client/components/Subscription/PremiumPlans/PremiumPlanOption.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAEE;EACE,mBAAA;MAAA,WAAA;UAAA,OAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,8BAAA;UAAA,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;AADJ;AAIE;EACE,qBCeO;ADjBX;AAKE;EACE,iBAAA;EACA,oBAAA;AAHJ;AAKI;EACE,cAAA;EACA,YAAA;AAHN;AAOE;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,cC7BW;ED8BX,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBCjCO;EDkCP,yBAAA;EACA,iBAAA;EACA,UAAA;EACA,UAAA;AALJ;AAOE;EACE,6BAAA;EACA,gCAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AALJ;AAMI;EACE,4BAAA;EACA,2BAAA;EACA,0BAAA;AAJN;AAMI;EACE,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cCNG;EDOH,kBAAA;AAJN;AAMI;EACE,qBAAA;EACA,WCxDE;EDyDF,mBAAA;EACA,iBAAA;EACA,yBCdG;EDeH,kBAAA;AAJN;AAOE;EACE,6BAAA;EACA,gCAAA;EACA,oBAAA;AALJ;AAMI;EACE,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cChFS;AD4Ef;AAMI;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAJN;AAOE;EACE,WCpFI;EDqFJ,6BAAA;EAAA,qBAAA;AALJ;AAQE;EACE,eAAA;EACA,gBAAA;EAEA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cCtGW;EDuGX,gBAAA;AAPJ;AAUE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cChHW;EDiHX,gBAAA;EACA,iBAAA;AARJ;AAWE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cC3HW;ED4HX,gBAAA;AATJ;AAYE;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cCnIW;EDoIX,eAAA;AAVJ;AAaE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cC3IW;ED4IX,eAAA;AAXJ;AAcE;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;AAZJ;AAcI;EACE,WAAA;EACA,8BAAA;UAAA,sBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;AAZN;AAaM;EACE,yBC9GA;ADmGR;AAgBE;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCtKW;EDuKX,gCAAA;EACA,6BAAA;AAdJ;AAiBE;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;AAfJ;AAkBE;EACE,oBAAA;EACA,gCAAA;EACA,mBAAA;AAhBJ","sourcesContent":["@import '../../../Global/Colors.scss';\n.PremiumPlanOption {\n  &--option {\n    flex: 1;\n    border: 1px solid $Gray30;\n    margin-left: 20px;\n    position: relative;\n    box-sizing: border-box;\n    padding-bottom: 36px;\n    max-width: 300px;\n    width: 270px;\n  }\n\n  &--current {\n    border-color: $Green120;\n  }\n\n  &__no-price-spacer {\n    line-height: 20px;\n    padding-bottom: 24px;\n\n    &:before {\n      display: block;\n      content: \" \";\n    }\n  }\n\n  &__recommended-badge {\n    position: absolute;\n    width: 100%;\n    font-size: 9px;\n    color: $DeepSeaGreen;\n    font-weight: 900;\n    text-align: center;\n    letter-spacing: 0.7px;\n    text-transform: uppercase;\n    background-color: $Lavender;\n    border: 1px solid $Lavender;\n    line-height: 22px;\n    top: -25px;\n    left: -1px;\n  }\n  &__current_ending {\n    border-top: 1px solid $DeepSeaGreen;\n    border-bottom: 1px solid $Gray20;\n    padding-top: 12px;\n    padding-bottom: 12px;\n    text-align: center;\n    &__cancel_link {\n      line-height: 23px !important;\n      font-weight: 500 !important;\n      font-size: 11px !important;\n    }\n    &__title {\n      line-height: 16px;\n      font-size: 14px;\n      text-transform: uppercase;\n      font-weight: 900;\n      text-align: center;\n      color: $Gray90;\n      margin-bottom: 7px;\n    }\n    &__status {\n      display: inline-block;\n      color: $White;\n      border-radius: 16px;\n      padding: 4px 10px;\n      background-color: $Gray90;\n      margin-bottom: 7px;\n    }\n  }\n  &__new_plan {\n    border-top: 1px solid $Gray20;\n    border-bottom: 1px solid $Gray20;\n    padding-bottom: 12px;\n    &__title {\n      padding-top: 12px;\n      line-height: 16px;\n      font-size: 14px;\n      text-transform: uppercase;\n      font-weight: 900;\n      text-align: center;\n      color: $DeepSeaGreen;\n    }\n    &__starting {\n      padding-top: 7px;\n      font-size: 11px;\n      font-weight: 500;\n      text-align: center;\n    }\n  }\n  &__link-button {\n    color: $White;\n    text-decoration: none;\n  }\n\n  &__name {\n    font-size: 14px;\n    font-weight: 900;\n\n    line-height: 1.14;\n    letter-spacing: 1.1px;\n    text-align: center;\n    text-transform: uppercase;\n    color: $DeepSeaGreen;\n    margin-top: 36px;\n  }\n\n  &__contact-us {\n    font-size: 1.3rem;\n    font-weight: 500;\n    font-style: normal;\n    font-stretch: normal;\n    text-align: center;\n    color: $DeepSeaGreen;\n    margin-top: 17px;\n    padding: 1.2rem 0;\n  }\n\n  &__price {\n    font-size: 32px;\n    font-weight: 300;\n    font-style: normal;\n    font-stretch: normal;\n    text-align: center;\n    color: $DeepSeaGreen;\n    margin-top: 17px;\n  }\n\n  &__price-label {\n    font-size: 14px;\n    font-weight: 500;\n    text-align: center;\n    color: $DeepSeaGreen;\n    margin-top: 7px;\n  }\n\n  &__price-label_secondary {\n    font-size: 14px;\n    font-weight: bold;\n    text-align: center;\n    color: $DeepSeaGreen;\n    margin-top: 7px;\n  }\n\n  &__action {\n    margin-top: 18px;\n    padding-left: 20px;\n    padding-right: 20px;\n\n    .Button {\n      width: 100%;\n      box-sizing: border-box;\n      line-height: 40px;\n      text-align: center;\n      padding-top: 0;\n      padding-bottom: 0;\n      &.cancel {\n        background-color: $Red10;\n      }\n    }\n  }\n\n  &__action-current {\n    line-height: 40px;\n    text-align: center;\n    font-size: 14px;\n    font-weight: bold;\n    color: $DeepSeaGreen;\n    border-bottom: 1px solid $Gray20;\n    border-top: 1px solid $Gray20;\n  }\n\n  &__features {\n    margin-top: 37px;\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n\n  &__feature-highlights {\n    padding-bottom: 15px;\n    border-bottom: 1px solid $Gray20;\n    margin-bottom: 15px;\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
